import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'
import { processTransaction } from '@/web3/services/transactionService.js'
import { disconnect } from '@wagmi/core'
import { config } from '@/web3/config/onramp.js'

export default class extends Controller {
  static outlets = ['app--wallet', 'visibility']
  static values = {
    amount: Number
  }

  connect() {
    this.visibilityOutlet.showLoader()
    this.setupEventListeners()
  }

  disconnect() {
    document.removeEventListener('transactionServiceEvent', this.handleTransactionServiceEvent)
  }

  async setupEventListeners() {
    await disconnect(config)
    this.appWalletOutlet.modal.adapter?.connectionControllerClient?.disconnect()
    document.addEventListener('transactionServiceEvent', this.handleTransactionServiceEvent)
    this.appWalletOutlet.modal.subscribeEvents(this.handleWalletEvents.bind(this))
  }

  async handleWalletEvents(event) {
    
    if (event.data.event === 'MODAL_LOADED') {
      this.appWalletOutlet.modal.open({ view: 'ConnectingWalletConnect' })
    } else if (event.data.event === 'MODAL_CLOSE' && this.appWalletOutlet.isConnected) {
      await this.processPayment()
    }
  }

  async processPayment() {
    const tokenDetails = {
      address: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
      symbol: "USDC",
      decimals: 6,
      name: "USDC"
    }
    await processTransaction(
      tokenDetails,
      this.appWalletOutlet.chain,
      this.amountValue,
      "bolo@me.com"
    )
  }

  handleTransactionServiceEvent = (event) => {
    const { state, token, chargeId } = event.detail
    
    switch (state) {
      case 'approve':
        this.visibilityOutlet.setMessage(`Approving ${token.symbol}`)
        break
      case 'approved':
        this.visibilityOutlet.setMessage(`${token.symbol} approved`)
        break
      case 'processing':
        if (chargeId) {
          this.visibilityOutlet.setMessage("Processing")
          const chargeElement = document.getElementById('charge')
          if (chargeElement) {
            chargeElement.innerHTML = this.getLoadingHTML(chargeId)
          }
        }
        break
    }
  }

  getLoadingHTML(chargeId) {
    return `
      <turbo-frame id="charge_${chargeId}">
        <div data-visibility-target="loader" class="absolute inset-0 rounded-[20px] overflow-hidden">
          <div class="loaderOverlay loader absolute inset-0 bg-[#141318] flex items-center justify-center z-50">
            <svg viewBox="25 25 50 50">
              <circle class="circle-large" cx="50" cy="50" r="20"></circle>
              <g style="transform-origin: 50px 50px; transform: scaleX(-1);">
                <circle class="circle-small" cx="50" cy="50" r="15"></circle>
              </g>
            </svg>
          </div>
        </div>
      </turbo-frame>
    `
  }
}